import BaseAPI from '@/services/api/internal/tools/baseAPI';

const Properties360API = new BaseAPI({
  url: `${process.env.ASSETS_BASE_URI}/properties_360`,
});

export default Properties360API;
